/* eslint-disable max-len */
import { useTranslation } from 'react-i18next'
import { Typography, Row, Col, Card, Space, Button } from 'antd'
import PageTitle from './PageTitle'

const { Title, Paragraph } = Typography

const LegalNotice = () => {
  const { i18n } = useTranslation()
  const lang = i18n.resolvedLanguage

  return (
    <Row justify="center" style={{ minHeight: '100vh', background: '#f6f6f6', paddingTop: 40 }}>
      <PageTitle title={lang === 'de' ? 'Impressum – Colozoo' : 'Legal Notice – Colozoo'} />
      <Col xs={24} md={20} lg={16}>
        {/* Language Switcher */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
          <Space>
            <Button
              type={lang === 'de' ? 'primary' : 'default'}
              size="small"
              onClick={() => i18n.changeLanguage('de')}
            >
              Deutsch
            </Button>
            <Button
              type={lang === 'en' || lang === 'en-US' ? 'primary' : 'default'}
              size="small"
              onClick={() => i18n.changeLanguage('en-US')}
            >
              English
            </Button>
          </Space>
        </div>
        <Card style={{ borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: 32, marginBottom: 42 }}>
          {lang === 'de' ? (
            <>
              <Title level={1}>Impressum</Title>
              <Paragraph>
                Angaben gemäß § 5 TMG:<br />
                <b>Viridian GmbH</b><br />
                vertreten durch geschäftsführenden Gesellschafter Ilia Zonov<br />
                Burgstr. 1<br />
                06114 Halle (Saale)<br />
              </Paragraph>
              <Paragraph>
                Telefon: +49 345 96391399<br />
                E-Mail: support@colozoo.de
              </Paragraph>
              <Paragraph>
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE350603872<br />
                Berufsbezeichnung: Händler
              </Paragraph>
              <Title level={2} style={{ marginTop: 32 }}>Haftungsausschluss (Disclaimer)</Title>
              <Title level={3}>Haftung für Inhalte</Title>
              <Paragraph>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </Paragraph>
              <Title level={3}>Urheberrecht</Title>
              <Paragraph>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </Paragraph>
              <Title level={3}>Nutzungsbedingungen für Online-Kurse</Title>
              <Paragraph>
                Die Online-Kurse von Colozoo sind ausschließlich für den persönlichen Gebrauch des registrierten Benutzers bestimmt. Jegliches Teilen, Herunterladen, Kopieren, Verbreiten oder anderweitige Vervielfältigung der Kursinhalte (Videos, Materialien, Texte) ist strengstens untersagt. Verstöße gegen diese Bedingungen können zum sofortigen Entzug des Zugangs führen und rechtliche Konsequenzen nach sich ziehen.
              </Paragraph>
              <Title level={3}>Streitschlichtung</Title>
              <Paragraph>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a><br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.<br />
                Weitere Informationen zu den nationalen Schlichtungsstellen finden Sie hier: <a href="https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.adr.show" target="_blank" rel="noopener noreferrer">ADR Kontaktstellen</a>
              </Paragraph>
            </>
          ) : (
            <>
              <Title level={1}>Legal Notice</Title>
              <Paragraph>
                Information according to § 5 TMG:<br />
                <b>Viridian GmbH</b><br />
                represented by managing partner Ilia Zonov<br />
                Burgstr. 1<br />
                06114 Halle (Saale), Germany<br />
              </Paragraph>
              <Paragraph>
                Phone: +49 345 96391399<br />
                Email: support@colozoo.de
              </Paragraph>
              <Paragraph>
                VAT ID according to §27 a German VAT Act: DE350603872<br />
                Business type: Merchant
              </Paragraph>
              <Title level={2} style={{ marginTop: 32 }}>Disclaimer</Title>
              <Title level={3}>Liability for Content</Title>
              <Paragraph>
                As a service provider, we are responsible for our own content on these pages in accordance with general laws pursuant to § 7 (1) TMG. According to §§ 8 to 10 TMG, however, we are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general laws remain unaffected. However, liability in this respect is only possible from the time of knowledge of a specific infringement. If we become aware of any such infringements, we will remove this content immediately.
              </Paragraph>
              <Title level={3}>Copyright</Title>
              <Paragraph>
                The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution, and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator. Downloads and copies of this site are only permitted for private, non-commercial use. Insofar as the content on this site was not created by the operator, the copyrights of third parties are respected. In particular, third-party content is identified as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. If we become aware of any infringements, we will remove such content immediately.
              </Paragraph>
              <Title level={3}>Terms of Use for Online Courses</Title>
              <Paragraph>
                The online courses from Colozoo are intended exclusively for the personal use of the registered user. Any sharing, downloading, copying, distributing, or otherwise reproducing course content (videos, materials, texts) is strictly prohibited. Violations of these terms may result in immediate loss of access and legal consequences.
              </Paragraph>
              <Title level={3}>Dispute Resolution</Title>
              <Paragraph>
                The European Commission provides a platform for online dispute resolution (ODR): <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a><br />
                Our email address can be found above in the legal notice.<br />
                For details of the nationally appointed Alternative Dispute Resolution bodies, see: <a href="https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.adr.show" target="_blank" rel="noopener noreferrer">ADR contact points</a>
              </Paragraph>
            </>
          )}
        </Card>
      </Col>
    </Row>
  )
}

export default LegalNotice
